import { ca } from '@cian/analytics';

type TParams = {
  chatId: string;
  messageId: string;
  isReply: boolean;
  ownerId?: number;
  mlSearchSessionGuid?: string;
  isEarlyAccess?: boolean;
  chatBotToAuthor?: boolean;
  products?: unknown;
};

export function trackMessageSent({
  chatId,
  messageId,
  isReply,
  ownerId,
  mlSearchSessionGuid,
  isEarlyAccess,
  chatBotToAuthor,
  products,
}: TParams) {
  ca('eventSite', {
    action: 'Click_sent',
    category: 'Chat',
    label: 'Messages',
    name: 'oldevent',
    page: {
      extra: {
        owner_id: ownerId,
        chat_id: chatId,
        message_id: messageId,
        mlSearchSessionGuid,
        is_early_access: isEarlyAccess,
        is_reply: isReply,
        chat_bot_to_author: chatBotToAuthor,
      },
    },
    products,
  });
}
